import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnResize } from "../../../library-js/dom-tools/EventListeners";
import { UIComponent } from "../../../library-js/dom-ui/components/UIComponent";
import { NodeGraph } from "../model/NodeGraph";
import { OverlaysLayer } from "./OverlaysLayer";
import { EdgesRenderingLayer } from "./EdgesRenderingLayer";

export class NodeGraphUI extends UIComponent
{
  static type = new ElementType( "node-graph" );

  static overlaysLayer = new ElementType( "overlays-layer" );
  static nodesLayer = new ElementType( "nodes-layer" );

  static edgesLayer = new ElementType( "edges-layer" );
  static backgroundLayer = new ElementType( "graph-bg-layer" );

  _nodeGraph:NodeGraph;

  _nodesLayer:HTMLElement;
  _overlaysLayer:OverlaysLayer;
  _edgesLayer:EdgesRenderingLayer;
  
  _backgroundLayer:HTMLElement;

  constructor( ng:NodeGraph )
  {
    super();
    this._nodeGraph = ng;
  }

  initialize( e:Element )
  {
    this._setElement( e );

    this._createLayers();

    OnResize.add( window, ()=> this.onResize() );

    this.onResize();

    
    setTimeout( ()=>{ this.onResize() }, 1000 );
  }

  _createLayers()
  {

    this._overlaysLayer = new OverlaysLayer( this._nodeGraph, NodeGraphUI.overlaysLayer.query( this.element  ) as HTMLElement);
    this._edgesLayer = new EdgesRenderingLayer( this._nodeGraph, NodeGraphUI.edgesLayer.query( this.element  ) as HTMLElement );
    
    this.onResize();
  }

  update()
  {

    //this.onResize();

  //  this.updateEdges();
  }

  onResize()
  {
    this._overlaysLayer.ensureCanvasSize();
    this._edgesLayer.ensureCanvasSize();
    this.updateEdges();
  }

  updateEdges()
  {
    this._nodeGraph._nodes.forEach( n => n.updateComponentConnectorPositions() );
    this._edgesLayer.redraw();
  }
}
